import React from 'react';
import MapIcon from '@mui/icons-material/Map';
import eventFormatter from '#component/device/event-formatter';
import PreloaderComponent from '#component/preloader';
import { EmptyLogs } from '#component/shipment/log/empty-log';
import EventDescription from '#component/shipment/log/event-description';
import LogCard from '#component/general/log-card';
import { StyledList } from './styles';

/**
 * Renders cards with log info.
 * @returns {React.FC}
 */

const MobileView = props => {
  const { account, loading, error, logs } = props;

  if (!logs.length && loading) {
    return <PreloaderComponent />;
  }

  if (error) {
    return <EmptyLogs />;
  }

  return (
    logs.length > 0 ? (
      <StyledList loading={loading}>
        {logs.map((log, id) => (
          <LogCard
            key={id}
            log={log}
            account={account}
            icon={<MapIcon />}
            EventDescriptionComponent={EventDescription}
            eventFormatter={eventFormatter}
          />
        ))}
      </StyledList>
    ) : (
      <EmptyLogs />
    )
  );
};

export default MobileView;
